<template>
  <div class="page-container">
    <CollapseResource
      title="教师成长"
      actionUrl="/resourceResearch"
      sortDictCode="teacher_growth_sort"
      :isShowSort="true"
      actionType="3"
    />
  </div>
</template>

<script>
import CreateSubjectModal from '@/comUi/CreateSubjectModal.vue'
import CollapseResource from '@/comUi/CollapseResource'

export default {
  name: 'TeacherResources',
  components: {
    CreateSubjectModal,
    CollapseResource,
  },
  data() {
    return {
      activeKey: [],
      activePaneObj: {},
      pageNo: 1,
      pageSize: 10,
      total: 0,
    }
  },
  created() {},
  methods: {},
}
</script>
<style scoped lang="less">
.collapse {
  /deep/ .ant-collapse {
    border: 1px solid #eef7ff;
  }
  .collapse-item {
    padding: 10px;
    margin: 4px;
    cursor: pointer;
    &:hover {
      //color: #fff;
      background-color: #eaf5ff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .active {
    background-color: #eaf5ff;
    border-radius: 4px;
  }
}
</style>
